import { ReactElement } from 'react';
import cx from 'clsx';
import { Button } from '@ff-it/ui';
import './FileContainer.scss';
import type { Attachment } from '../types';

interface FileContainerProps {
  files: Attachment[];
  markRemove?: (id: number) => void;
  disabled?: boolean;
}

function FileContainer({ files, markRemove, disabled }: FileContainerProps): ReactElement | null {
  if (files.length === 0) {
    return null;
  }
  return (
    <div className="card mb-1 file-container">
      <ul className="list-group list-group-flush">
        {files.map(({ file, filename, id }) => (
          <li
            key={id}
            className={cx('list-group-item d-flex justify-content-between align-items-center', {
              removed: !markRemove,
            })}
          >
            <a href={file} target="_blank" rel="noopener noreferrer">
              {filename}
            </a>
            {markRemove ? (
              disabled ? null : (
                <Button
                  className="border-0"
                  variant="secondary"
                  size="sm"
                  type="button"
                  onClick={() => markRemove(id)}
                  icon="trash"
                />
              )
            ) : (
              <Button className="border-0" variant="secondary" size="sm" type="button" disabled icon="trash" />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default FileContainer;
